import { render, staticRenderFns } from "./report_param2.vue?vue&type=template&id=24579dbf&scoped=true&"
import script from "./report_param2.vue?vue&type=script&lang=js&"
export * from "./report_param2.vue?vue&type=script&lang=js&"
import style0 from "./report_param2.vue?vue&type=style&index=0&id=24579dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24579dbf",
  null
  
)

export default component.exports